import React from "react";

interface User {
  id: number;
  name: string;
  role: string;
}

const Large: React.FC = () => {
  // Retrieve user data from localStorage safely
  const storedUser = localStorage.getItem("userData");
  const userInfo: User | null = storedUser ? JSON.parse(storedUser) : null;

  return (
    <section className="py-2">
      <div className="flex items-center justify-between px-6">
        <div className="flex items-center space-x-8 ml-4">
          <div className="flex items-center gap-3">
            <p className="font-bold capitalize text-lg tracking-wide">
              {userInfo?.name ?? "Guest"}
            </p>
            <span className="h-4 w-[1px] bg-gray-300"></span>
            <p className="text-gray-500 font-medium">
              {userInfo?.role ? userInfo.role.replace("_", " ") : "User"}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Large;
